import * as React from 'react'

import { Title } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'
import { SchoolPage_school_aggregateRatings, SchoolPage_school_reviews } from '../gql'
import { i18nKeyPrefix } from '../i18n'
import OverallRating from './OverallRating'
import Ratings from './Ratings'
import { Container } from './RatingsReviews.styles'
import Reviews from './Reviews'

const PRE = `${i18nKeyPrefix}-RATINGS-REVIEWS`

interface IProps {
  aggregateRatings: SchoolPage_school_aggregateRatings
  reviews: SchoolPage_school_reviews[]
}

export default function RatingsReviews(props: IProps) {
  const { aggregateRatings, reviews } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Container>
      <Title kind="large">{t(`${PRE}-TEXT`)}</Title>
      <OverallRating aggregateRatings={aggregateRatings} />
      <Ratings aggregateRatings={aggregateRatings} />
      {!!reviews.length && <Reviews reviews={reviews} />}
    </Container>
  )
}
